/**
 * Ryan O'Dowd
 * 2025-01-12
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Dialog as PaperDialog,
  Portal,
} from 'react-native-paper';
import Actions from './Actions';
import Content from './Content';
import React from 'react';
import Subtitle from './Subtitle';
import Title from './Title';
import getStyles from './styles';
import hooks from '@hooks';

const Dialog = (props: DialogProps & React.ComponentProps<typeof PaperDialog>) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <Portal>
      {props.visible && // @TODO: this shouldn't be needed...passing this prop to PaperDialog should be sufficient; however, there's a bug (probably in paper) where the fade-in animation doesn't finish without this (see TranslationSelectionDialog for an example); remove this conditional when paper is updated
        <PaperDialog
          {...props}
          style={[
            styles.container,
            props.fullWidth && styles.fullWidth,
            props.fullHeight && styles.fullHeight,
            props.style,
          ]}
        >
          {props.children}
        </PaperDialog>
      }
    </Portal>
  );
};

class DialogProps {
  fullWidth?: boolean;
  fullHeight?: boolean;
};

export default Dialog;

Dialog.Content = Content;
Dialog.Actions = Actions;
Dialog.Title = Title;
Dialog.Subtitle = Subtitle;
